import { FilterCheckbox, translateStage, useSettings } from "@repo/ui";
import { isChecked } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

export const StageFilter = ({ actions, filters }: FilterItemsProps) => {
  const { project_stages } = useSettings();
  const stages = project_stages?.stages?.map((s) => s.stage_key) ?? [];

  return (
    <FilterListContainer id="stage-filter">
      {stages.map((stage) => (
        <FilterCheckbox
          key={stage}
          id={stage}
          value={stage}
          label={translateStage(stage)}
          checked={isChecked(filters.stageFilter, stage)}
          onCheckFilter={actions.setStageFilter}
        />
      ))}
    </FilterListContainer>
  );
};
